import type { FeatureModule } from '@/shell/registry/types'

export default {
  code: 'mail',
  title: '邮箱',
  routes: [
    { path: '/mail', name: 'mail', component: () => import('./MailView.vue'), meta: {} },
  ],
} satisfies FeatureModule
